import DataSource from './DataSource'
import IframeMessenger from './IframeMessenger'

export default class IframeDataSource extends DataSource {
  constructor(options) {
    super(options)

    if (!options) {
      throw new Error('No configuration provided')
    }

    const url = options.url

    if (!url) { 
      throw new Error('No URL provided to IframeDataSource')
    }

    const iframe = document.createElement('iframe')
    iframe.setAttribute('src', url)
    iframe.setAttribute('class', 'hide')
    document.body.appendChild(iframe)

    this.messenger = new IframeMessenger({
      targetWindow: iframe
    })
  }

  request(callback, request) {
    this.messenger.message(callback, request)
  }
}